module.exports = __webpack_public_path__ + "static/media/retro-board-design.dbdaebce.png";